import React from "react";
import {SelectField} from "./FilterComponentStyles";

const DebtStatusFilter = ({
    value,
    onChange,
    disabled = false,
    showLabel = false,
    label = "Borç Durumu",
    allowClear = true,
    marginBottom = "0px",
    placeholder = "Borç Durumu"
}) => {
    return (
        <React.Fragment>
            {showLabel && <h5>{label}</h5>}
            <SelectField
                data-testid="debtStatusSelect"
                value={value}
                onChange={onChange}
                disabled={disabled}
                allowClear={allowClear}
                mb={marginBottom}
                placeholder={placeholder}
            >
                <SelectField.Option value={true} data-testid="debtStatusSelect_completed">
                    Tamamlanmış
                </SelectField.Option>
                <SelectField.Option value={false} data-testid="debtStatusSelect_incomplete">
                    Tamamlanmamış
                </SelectField.Option>
            </SelectField>
        </React.Fragment>
    );
};

export default DebtStatusFilter;
